
import React from 'react';

export const AppliedRuleTextPreview = (props: any) => {
    
    return (
        <div className="slds-grid marginTop15">
            <div className="slds-form-element full-width">
                <label className="slds-form-element__label">Applied Rule</label>
                <div className="slds-form-element__control">
                    <textarea id=""
                        readOnly={true}
                        placeholder="Placeholder Text" className="slds-textarea textarea-md" value={!props.isFormValid ? props.appliedRuleJSON : ''}></textarea>
                </div>
            </div>
        </div>
    );
}